import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "src/app/services/shared/state.service";
import { PaddleService } from "src/app/services/paddle/paddle.service";
import { map } from "rxjs/operators";
import { ModuleType } from "src/app/models/enums";
import { PopupService } from "src/app/services/shared/popup.service";
import { ApiService } from "src/app/services/api/api.service";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-in-app-navbar",
  templateUrl: "./in-app-navbar.component.html",
  styleUrls: ["./in-app-navbar.component.scss"],
})
export class InAppNavbarComponent implements OnInit {
  currentUser$!: Observable<any>;
  isPayingUser: boolean = false;
  IsTrialAlreadyUsed: boolean = false;
  isTrialUser: boolean = false;
  expiryDate: Date | undefined = new Date();
  moduleType = ModuleType;
  constructor(
    public stateService: StateService,
    public apiService: ApiService,
    public paddleService: PaddleService,
    public popupService: PopupService
  ) {}

  ngOnInit(): void {
    this.currentUser$ = this.stateService.user$;
    this.SubscribeToUser();
  }

  public SubscribeToUser() {
    this.stateService.user$.subscribe((user) => {
      this.isPayingUser = this.stateService.IsPayingUserState(user);
      this.IsTrialAlreadyUsed = this.stateService.IsTrialAlreadyUsed(user);
      this.isTrialUser = this.stateService.IsTrialUser(user);
      this.expiryDate = this.stateService.GetExpiryDate(user);
    });
  }

  public OpenPayingPlanPicker() {
    this.popupService.OpenPayingPlanPicker();
  }

  public async StartTrial() {
    const userResult = await this.apiService.GetUser();
    if (this.stateService.IsPayingUserState(userResult?.data)) {
      this.popupService.Notify("You already started trial.");
      this.stateService.UpdateUser(userResult?.data);
      return;
    }
    const result = await this.apiService.GetAvailablePlans();
    if (result?.errorMessage) this.popupService.Notify(result.errorMessage);
    if (result?.data && !this.popupService.modalOpened)
      this.popupService.OpenPremiumSubscription(result?.data.monthly);
  }
}
